import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=72ae545e&shadow"
import script from "./ChatWindow.vue?vue&type=script&lang=js&shadow"
export * from "./ChatWindow.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./ChatWindow.vue?vue&type=style&index=0&id=72ae545e&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports